'use client';

import { useState } from 'react';

export function useShare(titolo: string, testo?: string) {
  const [copied, setCopied] = useState(false);

  async function share() {
    const url = window.location.href;

    window.gtag?.('event', 'condivisione_evento', {
      event_category: 'engagement',
      event_label: titolo,
    });

    if (navigator.share) {
      try {
        await navigator.share({ title: `Terzo Tempo \u2013 ${titolo}`, text: testo ?? 'Vieni al Terzo Tempo!', url });
      } catch {
        // utente ha annullato o errore
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {
        // clipboard non disponibile
      }
    }
  }

  return { share, copied };
}
